export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for browsers that don't support navigator.clipboard
    console.error('Failed to copy to clipboard', err);
    return false;
  }
}
